import * as React from 'react';
import { SVGProps } from 'react';

const IconRingSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 2a2 2 0 0 0-1.98 2.284A7.003 7.003 0 0 0 7 11v7a2 2 0 1 0 0 4h14a2 2 0 1 0 0-4v-7a7.003 7.003 0 0 0-5.02-6.716A2 2 0 0 0 14 2ZM14 26a3 3 0 0 0 3-3h-6a3 3 0 0 0 3 3Z" />
  </svg>
);
export default IconRingSizeL;
